import moment from 'moment'

export default birthdate

/** @ngInject */
function birthdate() {
    return ({
        require: 'ngModel',
        link(scope, elm, attr, ctrl) {
            ctrl.$validators.isBirthdate = (value) => {
                return moment(value, 'DDMMYYYY').isValid()
            }
        },
    })
}



// WEBPACK FOOTER //
// ./src/directives/validators/birthdate/directive.js